{
  "DATA_ASSISTANT": {
    "TITLE": "Асистент даних",
    "NEW_CONVERSATION": "+ Нова",
    "LOADING": "Завантаження...",
    "LOADING_MESSAGES": "Завантаження повідомлень...",
    "THINKING": "Обробка...",
    "UNTITLED": "Розмова без назви",
    "NO_CONVERSATIONS": "Поки що немає розмов. Натисніть \"+ Нова\", щоб почати.",
    "EMPTY_STATE": "Виберіть розмову або створіть нову, щоб почати.",
    "SEND": "Надіслати",
    "PLACEHOLDER": "Що я можу для вас знайти?",
    "SHOW_SQL": "Показати SQL",
    "NO_ROWS": "Записів не повернуто.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Видалити розмову",
    "DELETE_CONFIRM_DESCRIPTION": "Ви впевнені, що хочете видалити цю розмову? Цю дію неможливо скасувати.",
    "DELETE_CONFIRM_YES": "Видалити",
    "CHAT": "Чат",
    "REPORTS": "Звіти",
    "SAVE_TO_REPORT": "Зберегти у звіт",
    "NEW_REPORT": "Новий звіт",
    "REPORT_NAME": "Назва звіту",
    "NO_REPORTS": "Поки що немає збережених звітів",
    "REPORTS_EMPTY_STATE": "Виберіть звіт або створіть новий.",
    "REPORT_SAVED": "Збережено у звіт",
    "DELETE_REPORT_CONFIRM": "Видалити звіт",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Ви впевнені, що хочете видалити цей звіт? Усі збережені елементи буде видалено.",
    "DELETE_ITEM_CONFIRM": "Видалити елемент",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Ви впевнені, що хочете видалити цей елемент зі звіту?",
    "EXPORT_CSV": "Експорт у CSV",
    "REFRESH": "Оновити",
    "QUERY_RUNNING": "Виконання запиту...",
    "QUERY_FAILED": "Помилка запиту",
    "AUTO_REFRESH": "Автооновлення",
    "AUTO_REFRESH_NONE": "Вручну",
    "AUTO_REFRESH_30S": "30 секунд",
    "AUTO_REFRESH_1M": "1 хвилина",
    "AUTO_REFRESH_5M": "5 хвилин",
    "AUTO_REFRESH_10M": "10 хвилин",
    "EDIT_MESSAGE": "Редагувати повідомлення",
    "RENAME_REPORT": "Перейменувати звіт",
    "RENAME_ITEM": "Перейменувати елемент",
    "MOVE_UP": "Перемістити вгору",
    "MOVE_DOWN": "Перемістити вниз",
    "COLLABORATORS": {
      "BUTTON": "Співавтори",
      "TITLE": "Співавтори звіту",
      "DESCRIPTION": "Виберіть, які агенти та команди можуть переглядати цей звіт.",
      "AGENTS": "Агенти",
      "TEAMS": "Команди",
      "SELECT_AGENTS": "Виберіть агентів",
      "SELECT_TEAMS": "Виберіть команди",
      "SAVE": "Зберегти",
      "SAVED": "Співавторів оновлено",
      "SAVE_FAILED": "Не вдалося оновити співавторів"
    }
  },
  "DATA_ASSISTANT_CHAT": "Чат",
  "DATA_ASSISTANT_REPORTS": "Звіти"
}
